"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// MIT © 2017 azu
var events_1 = require("events");
var SAVE = "SAVE";
var DELETE = "DELETE";
var RepositorySavedEvent = /** @class */ (function () {
    function RepositorySavedEvent(entity) {
        this.entity = entity;
        this.type = SAVE;
    }
    return RepositorySavedEvent;
}());
exports.RepositorySavedEvent = RepositorySavedEvent;
var RepositoryDeletedEvent = /** @class */ (function () {
    function RepositoryDeletedEvent(entity) {
        this.entity = entity;
        this.type = DELETE;
    }
    return RepositoryDeletedEvent;
}());
exports.RepositoryDeletedEvent = RepositoryDeletedEvent;
var RepositoryEventEmitter = /** @class */ (function () {
    function RepositoryEventEmitter() {
        this.eventEmitter = new events_1.EventEmitter();
        // disable EventEmitter Warning
        this.eventEmitter.setMaxListeners(0);
    }
    RepositoryEventEmitter.prototype.emit = function (event) {
        this.eventEmitter.emit(event.type, event);
    };
    RepositoryEventEmitter.prototype.onChange = function (handler) {
        var releaseHandlers = [this.onSave(handler), this.onDelete(handler)];
        return function () {
            releaseHandlers.forEach(function (event) {
                event();
            });
        };
    };
    RepositoryEventEmitter.prototype.onSave = function (handler) {
        var _this = this;
        this.eventEmitter.on(SAVE, handler);
        return function () {
            return _this.eventEmitter.removeListener(SAVE, handler);
        };
    };
    RepositoryEventEmitter.prototype.onDelete = function (handler) {
        var _this = this;
        this.eventEmitter.on(DELETE, handler);
        return function () {
            return _this.eventEmitter.removeListener(DELETE, handler);
        };
    };
    RepositoryEventEmitter.prototype.clear = function () {
        return this.eventEmitter.removeAllListeners();
    };
    return RepositoryEventEmitter;
}());
exports.RepositoryEventEmitter = RepositoryEventEmitter;
//# sourceMappingURL=RepositoryEventEmitter.js.map